import { useRef, useEffect } from 'react'

export const useInterval = (fn: (...args: any[]) => any, delay: number|undefined, args: any[]): void => {
  useEffect(() => {
    const filledArgs = args.filter(item => item !== null && item !== undefined).length
    const canRun = args.length === filledArgs

    if (canRun && delay) {
      const id = setTimeout(fn, delay * 1000)
      return (): void => clearTimeout(id)
    }
  }, [args, delay, fn])
}

export const useDebounce = (): any => {
  const timeout = useRef<any>()
  return (fn: (...args: any[]) => any, delay: number): void => {
    clearTimeout(timeout.current)
    timeout.current = setTimeout(fn, delay)
  }
}
